import React from "react";
import Traec from "traec";
import { ActionButton } from "./button";

const respondInvite = (invite, accept) => {
  let companyId = invite.getIn(["company", "uid"]);
  let inviteId = invite.get("uid");
  let fetch = new Traec.Fetch("company_invite_all", "patch", { companyId, inviteId });
  fetch.updateFetchParams({
    preFetchHook: (body) => ({
      accepted: accept,
      company: { uid: companyId },
    }),
  });
  fetch.dispatch();
};

function AcceptRejectButtons({ invite, isRequest }) {
  if (isRequest) {
    return (
      <React.Fragment>
        <ActionButton
          text="Awaiting approval"
          onClickHandler={(e) => {
            alert(
              "This request is pending approval from a colleague.  Contact your colleague or support for assistance in approving this request."
            );
          }}
        />
        <ActionButton
          color="danger"
          text="Delete"
          onClickHandler={(e) => {
            new Traec.Fetch("company_invite_all", "delete", { inviteId: invite.get("uid") }).dispatch();
          }}
        />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <ActionButton color="success" text="Accept" onClickHandler={(e) => respondInvite(invite, true)} />
      <ActionButton color="danger" text="Reject" onClickHandler={(e) => respondInvite(invite, false)} />
    </React.Fragment>
  );
}

export default function CompanyInviteItem(props) {
  let { index: i, invite } = props;
  if (!invite || !invite?.getInPath("company.name")) {
    return null;
  }

  return (
    <div className="list-group-item list-group-item-action" key={i}>
      <div className="d-flex justify-content-between align-items-center">
        <div className="flex-grow-1">
          <div className="row">
            <div className="col-sm-8">
              <h6 className="mb-1 font-weight-bold text-dark">{invite.getIn(["company", "name"])}</h6>
              <p className="mb-0 text-muted small">Role: {invite.getIn(["auth", "name"]) || "Member"}</p>
            </div>
          </div>
        </div>
        <div className="ml-3">
          <AcceptRejectButtons {...props} isRequest={invite.get("is_request")} />
        </div>
      </div>
    </div>
  );
}
